import { ModalController } from "@ionic/angular";
import { Component, OnInit } from "@angular/core";
import { AppService } from "../../app.service";
import { UTILITIES } from "../../core/utility/utilities";
import { constantsJson } from '../../core/constants/constants';
import moment from "moment";
import { Storage } from "@ionic/storage";
import { CONSTANTS } from "src/app/core/constants/constants";
import { AvtarListComponent  } from "../../components/avtar-list/avtar-list.component";
import { NgModule } from '@angular/core';
import { ComponentsModule } from "../../components/components.module";
import * as firebase from "firebase";
@Component({
  selector: "app-offer-popup",
  templateUrl: "./offer-popup.component.html",
  styleUrls: ["./offer-popup.component.scss"],
})
export class OfferPopupComponent implements OnInit  {
  data;
  profileData;
  isIOSDevice = false;
  countdownTimerText;
  countdownMins; 
  countdownSec; 
  countdownHours;
  country;
  poundValue = 0.453592;
  unit = "Kgs";
  activitySlider = [];
  containPlanTypes = [];
  selectedPlan = "weightLoss";
  planTypes:any;
  slideOptsVideo = {
    initialSlide: 0,
    slidesPerView: 1.4,
    loop: false,
    centeredSlides: false,
    spaceBetween: 1
  };
  freeTrialEndDateDiff;
  diseases = [];
  weightLossRemoved;
  isMainDiseases = false;
  constructor(public modalController: ModalController, private appService: AppService, private utilities: UTILITIES,private storage: Storage,) { }

  ngOnInit() {
    let activityArr = [];
    let selectedDietPlan = CONSTANTS.selectedDietPlan;
    if(['post_covid', 'diabetes', 'hypertension'].includes(selectedDietPlan)){
      activityArr = constantsJson.premiumPlanInculdes.filter((ele) =>{
        return ele.title != "Detox Plan";
      })
      this.activitySlider = activityArr;
    }else{
      this.activitySlider = constantsJson.premiumPlanInculdes;
    }
    console.log("Data ", this.data);
    this.checkDieses();
    this.isIOSDevice = this.utilities.isDeviceiOS();
    this.utilities.logEvent("View_Offer", {});
    this.storage.get("localData").then(val => {
      let data = this.utilities.parseJSON(val);
      if(data.otherMaster.weight[0].param == "pound"){
          this.profileData.suggestedWeight= Math.round(parseInt(data.otherMaster.bmi.suggestedWeight) / this.poundValue);
          this.unit = "pounds";
       }
    })
    this.countDown()
  }

  expandPlanCards = false;
  toggelExpandCards(event, flag){
    event.stopPropagation();
    if(!this.expandPlanCards || flag) this.expandPlanCards = !this.expandPlanCards;
  }

  checkDieses(){
    this.storage.get("localData").then(val => {
      if (val != "") {
        let data = JSON.parse(val);
        this.diseases = data.otherMaster.diseases.filter(item=>{
          return item.isSelected==true;
        });
        this.initPlanData();
      }else{
        this.initPlanData();
      }
    })
  }

  async initPlanData(){
    // const snapshot = await firebase.firestore().collection("diet_plans").get();
    let planTypes = constantsJson.diet_plans;//snapshot.docs.map(doc => doc.data());
    let self = this;
    let tempPlanTypes;
    planTypes = planTypes.filter((ele) =>{
      return ele.isVisible;
    })
    this.storage.get("profileData").then((res)=>{
      let profileData = JSON.parse(res);
      if(profileData && profileData["lifeStyle"] &&  profileData["lifeStyle"]["dietPlanName"]){
        self.selectedPlan = profileData["lifeStyle"]["dietPlanName"];
      } else {
        self.selectedPlan = "weightLoss";
      }
      if(profileData.demographic.gender.gender.toLowerCase() == 'male'){
        tempPlanTypes = planTypes.filter((ele) =>{
          if(ele.id.toLowerCase() != "pcos"){
            return ele;
          }
        })
      }else{
        tempPlanTypes = planTypes;
      }

      if(this.diseases.length > 0){
        let isDiabetes, isPCOD, isCholestrol, isBloodPressure; 
        this.diseases.forEach((ele)=>{
          if(ele.code == "D") isDiabetes = true;
          else if(ele.code == "P") isPCOD = true;
          else if(ele.code == "C") isCholestrol = true;
          else if(ele.code == "B") isBloodPressure = true;
        })
        if(isBloodPressure || isCholestrol || isPCOD || isDiabetes) this.isMainDiseases = true;
        tempPlanTypes.unshift(tempPlanTypes.splice(tempPlanTypes.findIndex(item => item.id === "weightLoss"), 1)[0]);
        tempPlanTypes.unshift(tempPlanTypes.splice(tempPlanTypes.findIndex(item => item.id === "weightLossPlus"), 1)[0]);
        if(isBloodPressure) tempPlanTypes.unshift(tempPlanTypes.splice(tempPlanTypes.findIndex(item => item.id === "hypertension"), 1)[0]); //.sort((a, b) =>{ return (a.id != 'hypertension' ? 1 : -1)});
        if(isCholestrol) tempPlanTypes.unshift(tempPlanTypes.splice(tempPlanTypes.findIndex(item => item.id === "cholesterol"), 1)[0]); //sort((a, b) =>{ return (a.id != 'cholesterol' ? 1 : -1) });
        if(isPCOD) tempPlanTypes.unshift(tempPlanTypes.splice(tempPlanTypes.findIndex(item => item.id === "pcos"), 1)[0]); //tempPlanTypes.sort((a, b) =>{ return (a.id != 'pcos' ? 1 : -1) });
        if(isDiabetes) tempPlanTypes.unshift(tempPlanTypes.splice(tempPlanTypes.findIndex(item => item.id === "diabetes"), 1)[0]); //tempPlanTypes.sort((a, b) =>{ return (a.id != 'diabetes' ? 1 : -1) });
        if(this.weightLossRemoved){
          this.planTypes = tempPlanTypes.filter((ele) =>{
            return ele.name != "Weight Loss" 
          })
        }else{
          this.planTypes = tempPlanTypes;
        }
        this.containPlanTypes = this.planTypes;
      }else{
        tempPlanTypes.unshift(tempPlanTypes.splice(tempPlanTypes.findIndex(item => item.id === "weightLoss"), 1)[0]); 
        tempPlanTypes.unshift(tempPlanTypes.splice(tempPlanTypes.findIndex(item => item.id === "weightLossPlus"), 1)[0]);
        if(this.weightLossRemoved){
          this.planTypes = tempPlanTypes.filter((ele) =>{
            return ele.name != "Weight Loss" 
          })
        }else{
          this.planTypes = tempPlanTypes;
        }
  
        // this.planTypes.unshift(this.planTypes.splice(this.planTypes.findIndex(item => item.id === self.selectedPlan), 1)[0]);
        this.containPlanTypes = [] = this.planTypes;
      }
    })
  }
  
  countDown(){
    let deadline = new Date(localStorage.getItem("countDownTimer")).getTime();
    let a = moment(new Date(localStorage.getItem("countDownTimer")), "DD.MM.YYYY");
    let b = moment(new Date(), "DD.MM.YYYY");
    this.freeTrialEndDateDiff = a.diff(b, 'days');
    if(this.freeTrialEndDateDiff == 0){
      let self = this;
      let x = setInterval(function () {
        let now = new Date().getTime();
        let t = deadline - now;
        if (t < 0) {
          clearInterval(x);
          console.log("offer page");
          localStorage.setItem("offerTimeExpired", "true");
          self.close(false);
          return false;
        }
  
        let hours = Math.floor((t % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minutes = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((t % (1000 * 60)) / 1000);
  
        self.countdownHours = (hours <= 9 ? "0" + hours : hours);
        self.countdownMins = (minutes <= 9 ? "0" + minutes : minutes);
        self.countdownSec = (seconds <= 9 ? "0" + seconds : seconds);
        self.countdownTimerText = (minutes <= 9 ? "0" + minutes : minutes) + ":" + (seconds <= 9 ? "0" + seconds : seconds);
      }, 1000);
    }
  }

  close(flag) {
    let data;
    if(flag) data = this.data;
    this.modalController.dismiss(data);
  }
}
